import { useEffect, useState } from "react";
import { CornerMarks } from "@/components/infra";
import { QUOTE_BANK } from "@/lib/wireData";

export const QuoteCarousel = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % QUOTE_BANK.length), 5000);
    return () => clearInterval(t);
  }, [paused]);

  const q = QUOTE_BANK[index];

  return (
    <figure
      data-testid="quote-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      className="chrome-surface relative p-7 md:p-12 mt-6 md:mt-8"
    >
      <CornerMarks color="#A9ADB4" />
      <div className="flex items-center justify-between mb-6">
        <span className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#5F6168]">
          From the coverage
        </span>
        <span className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#5F6168]">
          {String(index + 1).padStart(2, "0")} / {String(QUOTE_BANK.length).padStart(2, "0")}
        </span>
      </div>
      <div key={index} className="quote-fade">
        <blockquote
          data-testid="quote-carousel-text"
          className="font-display text-xl sm:text-2xl lg:text-[32px] font-extrabold tracking-tight leading-[1.15] text-[#0F1117] text-balance max-w-4xl min-h-[88px] md:min-h-[110px]"
        >
          “{q.quote}”
        </blockquote>
        <figcaption
          data-testid="quote-carousel-source"
          className="mt-5 font-mono-label text-[10.5px] tracking-[0.18em] uppercase text-[#71747B]"
        >
          — {q.source}
        </figcaption>
      </div>
      <div className="mt-6 flex items-center gap-2">
        {QUOTE_BANK.map((_, i) => (
          <button
            key={i}
            type="button"
            data-testid={`quote-carousel-dot-${i}`}
            aria-label={`Show quote ${i + 1}`}
            onClick={() => setIndex(i)}
            className={`h-[3px] transition-all duration-300 ${
              i === index ? "w-8 bg-[#0F1117]" : "w-4 bg-[#C6C9CF] hover:bg-[#9498A0]"
            }`}
          />
        ))}
      </div>
    </figure>
  );
};

export default QuoteCarousel;
